import Sidebar from '../widgets/sidebar';

import './style';

export interface ContentProps extends React.PropsWithChildren<any> {
  title?: string | React.ReactChild;
}

const Content: React.FC<ContentProps> = ({ title, children }) => {
  const styles = { height: 'calc(100% - 0px)', paddingTop: '0.7rem' };
  return (
    <main className="content-component">
      <nav className="navbar-top">
        <button className="sidebar-toggle" onClick={Sidebar.onToggleButtonClick}>
          <i className="fal fa-bars"></i>
        </button>
        <span className="d-md-inline-flex w-100 d-none">{title ?? 'داشبورد'}</span>
        <span className="d-md-none d-inline-flex">دارستان صنعت</span>
      </nav>
      <div className="content-inner h-100">
        <div className="col-12" style={styles}>
          {children}
        </div>
      </div>
    </main>
  );
}

export default Content;
